/** @prettier */
import React from "react";
import "react-table/react-table.css";
import "./AuditorQuestionsList.css";
import QuestionList from "../QuestionList/QuestionList";
import { User, Subscription } from "../services/qbankApi";

type WriterDashboardProps = {
    me: User;
    activeSubscription: Subscription;
};

const AuditorQuestionsList = ({
    me,
    activeSubscription,
}: WriterDashboardProps) => (
    <div className="auditor-questions-list">
        <div className="dashboard-header">
            <h3 className="dashboard-title">Audit Questions</h3>
        </div>
        <div className="grid-container">
            <QuestionList
                role="auditor"
                me={me}
                activeSubscription={activeSubscription}
            />
        </div>
    </div>
);

export default AuditorQuestionsList;
